export default __webpack_public_path__ + "static/media/terms-gray.9e35a5b9.svg";